import { render, staticRenderFns } from "./TablePageToken.vue?vue&type=template&id=22ac73d9"
import script from "./TablePageToken.vue?vue&type=script&lang=js"
export * from "./TablePageToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports